import { DollarSign, Home, Car, FileText, ShieldCheck, Repeat, Heart, Plane, ShoppingBag, Users, PawPrint, Layers } from "lucide-react";
import i18n from "../i18n";
import { LOCALE_MAP } from "../i18n";

// Category id is the canonical key; visible labels are translated via i18n (categories.<id>).
export const CATEGORIES = [
  { id: "money", color: "#059669", bg: "#ECFDF5", icon: DollarSign },
  { id: "home", color: "#D97706", bg: "#FFFBEB", icon: Home },
  { id: "car", color: "#2563EB", bg: "#EFF6FF", icon: Car },
  { id: "documents", color: "#4F46E5", bg: "#EEF2FF", icon: FileText },
  { id: "insurance", color: "#0D9488", bg: "#F0FDFA", icon: ShieldCheck },
  { id: "subscriptions", color: "#9333EA", bg: "#FAF5FF", icon: Repeat },
  { id: "health", color: "#E11D48", bg: "#FFF1F2", icon: Heart },
  { id: "travel", color: "#0284C7", bg: "#F0F9FF", icon: Plane },
  { id: "purchases", color: "#C2410C", bg: "#FFF7ED", icon: ShoppingBag },
  { id: "family", color: "#DB2777", bg: "#FDF2F8", icon: Users },
  { id: "pets", color: "#B45309", bg: "#FEF3C7", icon: PawPrint },
  { id: "other", color: "#4B5563", bg: "#F3F4F6", icon: Layers },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.id, c]));

export const PRIORITIES = ["low", "medium", "high"];
export const RECURRENCES = ["none", "daily", "weekly", "monthly", "quarterly", "yearly"];
export const EVENT_TYPES = ["payment_due", "renewal", "expiration", "return_deadline", "event", "appointment", "issue_date", "document_date", "billing_period", "other"];

// Only visual classes here; labels come from i18n (status.<key>).
export const STATUS_STYLES = {
  overdue: "bg-red-50 text-red-600 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-900",
  due: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900",
  upcoming: "bg-green-50 text-green-700 border-green-200 dark:bg-green-950/40 dark:text-green-300 dark:border-green-900",
  completed: "bg-gray-100 text-gray-500 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700",
  archived: "bg-gray-100 text-gray-500 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700",
};

export function formatDate(iso) {
  if (!iso) return i18n.t("dates.noDate");
  const locale = LOCALE_MAP[i18n.language] || "en-GB";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString(locale, { month: "short", day: "numeric", year: "numeric" });
}

export function relativeDate(iso) {
  if (!iso) return "";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(iso + "T00:00:00");
  const days = Math.round((d - today) / 86400000);
  if (days < 0) return i18n.t("dates.overdue", { count: Math.abs(days) });
  if (days === 0) return i18n.t("dates.today");
  if (days === 1) return i18n.t("dates.tomorrow");
  if (days < 7) return i18n.t("dates.inDays", { count: days });
  return formatDate(iso);
}
